export default __webpack_public_path__ + "static/media/2.7ac37e12.jpg";